<!--
 * @Author: DY
 * @Date: 2024-12-05 16:52:54
 * @LastEditTime: 2025-03-17 17:36:38
 * @Description: 原材料领用审核列表
 * @FilePath: \ShiMo_Mobile\src\views\storage\rawMaterialRequisitionApproval\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="rawMaterialRequisitionApproval commonListStyles">
            <HeaderNav header-title="原材料领用审核" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">出库单号：{{ item.outstock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status | loadStatus }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>申请人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_4@2x.png" alt="">
                                            <span>领用部门：{{ item.dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>领用部门负责人：{{ item.manage_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>库管员：{{ item.outstock_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>制单时间：{{ item.time1 }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="loadBtn(item) == 1">
                                            <button @click="editApply(item, 'edit')">
                                                审批
                                            </button>
                                        </template>
                                        <template v-if="loadBtn(item) == 2">
                                            <button @click="editApply(item, 'see')">
                                                查看
                                            </button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'material-requisition-review',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'material-requisition-review');
        }
        next();
    },
    data() {
        return {
            tableCode: 'outstock_raw_material_check1',
            listType: 1,
        };
    },
    filters: {
        loadStatus(val) {
            const status = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return status[val];
        },
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        loadBtn(item) {
            const Uid = this.$takeTokenParameters('Uid');
            // status=1 且 manage_id=当前用户  或者 (outstock_user_id=当前用户 且 status= 3
            if (item.status === 1 && item.manage_id === Uid || item.outstock_user_id === Uid && item.status === 3) {
                return 1;
            }
            return 2;
        },
        editApply(item, type) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'rawMaterialRequisitionApprovalForm', params: { type, data: item } });
        },
    },
};
</script>
<style lang="stylus">
.rawMaterialRequisitionApproval
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    section
        .van-pull-refresh
            height: calc(100% - 44rpx) !important
</style>
